// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import  'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import Public from './util/public.js';

Vue.prototype.public = Public;
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer);

Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.prototype.activeIndex =''

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});
// global.activeIndex = 1





// WEBPACK FOOTER //
// ./src/main.js